import * as moment from 'moment';

export function generateYearsSelectOptions(
  from: Date,
  n: number,
): { year: string }[] {
  const years: { year: string }[] = [];
  for (let i = 0; i < n; i++) {
    years.push({
      year: moment(from).subtract(i, 'year').format('YYYY'),
    });
  }
  return years;
}
